import styled from 'styled-components';

export const Style = styled.div`
  overflow: auto;
  border-right: 1px solid #eaecf0;
  max-height: 664px;
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);

  .item {
    display: flex;
    border-bottom: 1px solid #EAECF0;
    padding-top: 12px;
    padding-bottom: 12px;
    cursor: pointer;

    &.active {
      background: #F5FBFF;
    }

    .main {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;

      label {
        margin-bottom: 0px;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
`;
